import * as actionTypes from '../../actionTypes'
import { updateObject } from '../../../utility/Redux'
import { default_playlists } from './default_playlists'
import _ from 'lodash'
import { getRandomInt } from '../../../utility/helper'
const initialState = {
    token: "",
    device: "",
    playlist: {},
    tracks: [],
    isAlreadyPlaying: false,
    track_no: 1,
    control_initializing: true,
    webplayer_status: 'idle',
    selected: null,
    next: null,
    answer_options: {},
    answer: {},
    default_playlists,
    support: {
        widevine: {
            support: false,
            alias: 'Chrome/ Firefox',
        },
        fairplay: {
            support: false,
            alias: 'Safari'
        },
        playready: {
            support: false,
            alias: 'IE/ Edge'
        },
        // clearkey: {
        //     support: false,
        //     alias: 'Other',
        // },
    }
}

const handlePlaylist = playlist => {
    return{
        id: playlist.id,
        images: playlist.images[0].url,
        name: playlist.name,

    }
}

const handleTracks = playlist => {
    const tracks = playlist.tracks
    const shuffled = _.shuffle(tracks.items)
    return _.shuffle(shuffled.map((track) => {
        if(track.track?.duration_ms && track.track?.name){
            const duration_ms = (track.track.duration_ms/1000)-50
            const current_ms = 20000+(getRandomInt(duration_ms)*1000)
            const uri = {
                context_uri: track.track.album.uri,
                offset: {
                    uri: track.track.uri,
                },
                position_ms: current_ms,
                id: track.track.id
            }
            return{
                id: track.track?.id,
                album: track.track?.album.images[2].url,
                // artist: [...track.track?.artists.map(artist => artist.name)].join(", "),
                artist: track.track.artists[0].name,
                name: track.track.name,
                uri,
                preview_url: track.track.preview_url
            }
        }
        return null
    }))
}

const shiftAndTake = (tracks) => {
    const selected_track = _.head(tracks)
    const unique_tracks = tracks.filter(track => track !== selected_track)
    const taken_tracks = _.sampleSize(unique_tracks, 3)
    return {
        options: taken_tracks,
        answer: selected_track
    }
}

const handleAnswerOptions = tracks => {
    const sat = shiftAndTake(tracks)
    const name = _.shuffle([...sat.options.map(track => track.name), sat.answer.name])
    const artist = _.shuffle([...sat.options.map(track => track.artist), sat.answer.artist])
    return{
        name: _.shuffle(name),
        artist: _.shuffle(artist)
    }
}

const handleAnswer = tracks => {
    return{
        name: _.head(tracks).name,
        artist: _.head(tracks).artist
    }
}

const handleSelected = (track) => {
    return{
        id: track.id,
        album: track.album,
        artist: track.artist,
        name: track.name,
        uri: track.uri,
        preview_url: track.preview_url
    }
}

const reducer =(state = initialState, action) => {
    switch(action.type){
        case actionTypes.SPOTIFY_SET_TOKEN:
            return updateObject(state, {token: action.token})
        case actionTypes.SPOTIFY_REMOVE_TOKEN:
            return updateObject(state, {token: ""})
        case actionTypes.SPOTIFY_SET_DEVICE:
            return updateObject(state, {device: action.device})
        case actionTypes.SPOTIFY_SET_WEB_PLAYER_STATUS:
            return updateObject(state, {webplayer_status: action.webplayer_status})
        case actionTypes.SPOTIFY_SET_CONTROL_INITIALIZING:
            return updateObject(state, {control_initializing: action.control_initializing, webplayer_status: 'start', track_no: 1})
        case actionTypes.SPOTIFY_SET_PLAYLIST:
            const playlist = handlePlaylist(action.playlist)
            return updateObject(state, {playlist, tracks: handleTracks(action.playlist).filter(v => v), isAlreadyPlaying: true})
        case actionTypes.SPOTIFY_REMOVE_PLAYLIST:
            return updateObject(state, {playlist: "", tracks: ""})
        case actionTypes.SPOTIFY_RESET_TRACK_NO:
            return updateObject(state, {track_no: 1})
        case actionTypes.SPOTIFY_SET_PLAY:
            const selected = handleSelected(state.tracks[0])
            const next = handleSelected(state.tracks[1])
            return updateObject(state, {selected, next})
        case actionTypes.SPOTIFY_SET_NEXT:
            const tracks = _.drop(state.tracks)
            return updateObject(state, {tracks, track_no: state.track_no+1, answer_options: handleAnswerOptions(tracks), answer: handleAnswer(tracks)})
        case actionTypes.SPOTIFY_SET_ANSWER_OPTIONS:
            return updateObject(state, {answer_options: handleAnswerOptions(state.tracks), answer: handleAnswer(state.tracks)})
        case actionTypes.SPOTIFY_SET_DRM_SUPPORT:
            return updateObject(state, {support: action.support})
        default:
            return state
    }
}

export default reducer